  function openModal() {
    if (count() === 0) return;
    trayClosed = true; // kleines Sticky ausblenden, während Modal offen ist
    modalOpen = true;
    ensureModal();
    renderModal();
    modalEl.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    applyTrayVisibility();
  }
  function closeModal() {
    modalOpen = false;
    if (modalEl) modalEl.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    updateReopen();
  }

  // ---- Init + observe (eigene UI-Mutationen ignorieren -> keine Render-Schleife) ----
  function isOurNode(nd) {
    if (nd.nodeType !== 1 || !nd.classList) return false;
    return nd.classList.contains('muster-tray') || nd.classList.contains('muster-toast') ||
           nd.classList.contains('muster-badge') || nd.classList.contains('muster-modal') ||
           nd.classList.contains('muster-reopen');
  }
  var t;
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () { injectCards(document); enrichCards(document); injectPdp(); relabelPdpCta(); relabelMhSample(); syncAll(); }, 150);
  }
  function init() {
    injectCards(document);
    enrichCards(document);
    injectPdp();
    hookPdpAddButtons();
    relabelPdpCta();
    relabelMhSample();
    renderTray();
    updateReopen();
    if (window.MutationObserver) {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.target && m.target.closest && m.target.closest('.muster-tray, .muster-toast, .muster-modal')) continue;
          if (!m.addedNodes || !m.addedNodes.length) continue;
          var relevant = false;
          for (var j = 0; j < m.addedNodes.length; j++) {
            if (!isOurNode(m.addedNodes[j])) { relevant = true; break; }
          }
          if (relevant) { refresh(); return; }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
    var raf;
    function onScrollResize() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; positionTray(); });
    }
    window.addEventListener('scroll', onScrollResize, { passive: true });
    window.addEventListener('resize', onScrollResize);
    // Tray aus-/einblenden, wenn der Warenkorb-Drawer auf-/zugeht
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(applyTrayVisibility).observe(cd, { attributes: true, attributeFilter: ['open', 'class'] });
    }
  }
  if (!window.__musterBadgeInit) { window.__musterBadgeInit = true; if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); } }

  /* ---- Patch: Header-Zaehler immer sichtbar (auch 0/5); Sticky nur einmal ---- */
  (function () {
    var DKEY = 'myharry_musterbox_traydismissed';
    function dismissed() { try { return localStorage.getItem(DKEY) === '1'; } catch (e) { return false; } }
    function markDismissed() { try { localStorage.setItem(DKEY, '1'); } catch (e) {} }

    // 1) Kopfzeilen-Anzeige immer einblenden, auch bei 0 Mustern
    updateReopen = function () {
      var el = ensureReopen();
      if (!el) return;
      var n = count();
      var txt = el.querySelector('.muster-reopen__txt') || el;
      txt.textContent = n + ' / ' + MAX + ' Muster';
      el.classList.add('is-visible');
    };

    // 2) Sticky nur einmal automatisch; nach Schliessen nicht mehr (persistent)
    applyTrayVisibility = function () {
      if (!trayEl) { updateReopen(); return; }
      var vis = count() > 0 && !dismissed() && !modalOpen && !isDrawerOpen();
      trayEl.classList.toggle('is-visible', vis);
      updateReopen();
    };

    // Modal darf auch bei 0 Mustern ueber die Kopfzeile geoeffnet werden
    openModal = function () {
      modalOpen = true;
      ensureModal();
      renderModal();
      modalEl.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      applyTrayVisibility();
    };

    // Schliessen der Sticky dauerhaft merken
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.muster-tray__close')) markDismissed();
    }, true);

    // 3) Leer-Ansicht (kein Muster gewaehlt): Muster-Collections zeigen, verlinkt
    var MUSTER_COLLECTIONS = [
      { label: 'WPC-Dielen', url: '/collections/wpc-dielen-muster', img: 'https://cdn.shopify.com/s/files/1/0335/0908/1133/collections/WPC_Diele_Muster.webp?v=1781862243' },
      { label: 'Terrassenplatten', url: '/collections/terrassenplatten-muster', img: 'https://cdn.shopify.com/s/files/1/0335/0908/1133/collections/Design_ohne_Titel_1.png?v=1685631159' },
      { label: 'Sichtschutzzaun', url: '/collections/muster-sichstschutzzaun', img: 'https://cdn.shopify.com/s/files/1/0335/0908/1133/files/WPC-Zaun-Elfenbein.jpg?v=1759328389' },
      { label: 'Stelzlager Testpaket', url: '/collections/stelzlager-testpaket', img: 'https://cdn.shopify.com/s/files/1/0335/0908/1133/collections/Stelzlager-Testpaket.jpg?v=1781861604' },
      { label: 'Akustikpaneele', url: '/collections/akustikpaneele-muster', img: 'https://cdn.shopify.com/s/files/1/0335/0908/1133/collections/Design_ohne_Titel_4.png?v=1779350199' },
      { label: 'SPC-Platten', url: '/collections/spc-muster', img: 'https://cdn.shopify.com/s/files/1/0335/0908/1133/collections/Design_ohne_Titel_9_2e9e9062-e97b-4023-89c3-7feca86cfb20.png?v=1767799188' }
    ];
    function renderEmptyModal() {
      var card = ensureModal().querySelector('.muster-modal__card');
      if (modalSig === '__empty__' && card.querySelector('.muster-modal__slot--coll')) return;
      modalSig = '__empty__';
      var tiles = '';
      for (var i = 0; i < MUSTER_COLLECTIONS.length; i++) {
        var c = MUSTER_COLLECTIONS[i];
        tiles += '<a class="muster-modal__slot muster-modal__slot--filled muster-modal__slot--coll" href="' + esc(c.url) + '" style="text-decoration:none">' +
          (c.img ? '<img src="' + esc(c.img) + '" alt="">' : '') +
          '<span class="muster-modal__slot-label">' + esc(c.label) + '</span>' +
          '</a>';
      }
      card.innerHTML =
        '<button type="button" class="muster-modal__close" aria-label="Schliessen">' + ICON_X + '</button>' +
        '<div class="muster-modal__body">' +
        '<h2 class="muster-modal__title">Kostenlose Muster auswählen</h2>' +
        '<div class="muster-modal__grid">' + tiles + '</div>' +
        '<p class="muster-modal__hint">Bestelle dir bis zu <b>' + MAX + ' kostenlose Muster</b> nach Hause und finde deinen Favoriten.</p>' +
        '</div>' + contactHtml();
      var cl = card.querySelector('.muster-modal__close');
      if (cl) cl.addEventListener('click', closeModal);
    }
    var _origRenderModal = renderModal;
    renderModal = function () {
      if (window.__mbQuestionsOpen) return; // Fragen-Schritt nicht durch Re-Render ueberschreiben
      if (count() === 0) { renderEmptyModal(); } else { _origRenderModal(); }
    };

    // 4) "Fly to cart": Musterbild fliegt beim Auswaehlen in die Kopfzeilen-Anzeige
    function flyToBanner(rectEl, src) {
      try {
        var target = document.querySelector('.muster-reopen');
        if (!target || !rectEl || !src) return;
        var s = rectEl.getBoundingClientRect();
        if (!s.width || !s.height) return;
        var tb = target.getBoundingClientRect();
        var fly = document.createElement('img');
        fly.src = src;
        fly.setAttribute('aria-hidden', 'true');
        fly.style.cssText = 'position:fixed;left:' + s.left + 'px;top:' + s.top + 'px;width:' + s.width + 'px;height:' + s.height + 'px;border-radius:12px;object-fit:cover;z-index:100001;pointer-events:none;box-shadow:0 10px 26px rgba(0,0,0,.28);transition:transform .8s cubic-bezier(.22,.68,.28,1),opacity .8s ease;will-change:transform,opacity;';
        document.body.appendChild(fly);
        var dx = (tb.left + tb.width / 2) - (s.left + s.width / 2);
        var dy = (tb.top + tb.height / 2) - (s.top + s.height / 2);
        fly.getBoundingClientRect();
        requestAnimationFrame(function () {
          fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.08) rotate(6deg)';
          fly.style.opacity = '0.3';
        });
        setTimeout(function () {
          if (fly.parentNode) fly.parentNode.removeChild(fly);
          if (target.animate) { try { target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 300, easing: 'ease' }); } catch (e) {} }
        }, 820);
      } catch (e) {}
    }
    function pdpMediaImg() {
      return document.querySelector('.product__media-wrapper img, .product-media-container img, media-gallery img, .product__media img, .product-single__media img');
    }
    document.addEventListener('click', function (e) {
      var tg = e.target;
      if (!tg || !tg.closest) return;
      var badge = tg.closest('.muster-badge');
      if (badge) {
        var id = badge.getAttribute('data-muster-id');
        if (id && typeof has === 'function' && !has(id)) {
          var host = badge.closest('product-card, .product__media-wrapper, .product-media-container, media-gallery, .product-card, .card-wrapper, .card') || badge.parentElement;
          var img = host ? host.querySelector('img') : null;
          flyToBanner(img || badge, (img && (img.currentSrc || img.src)) || badge.getAttribute('data-muster-img'));
        }
        return;
      }
      var mh = tg.closest('.mh-sample__btn, .mh-sample__inner [name="add"]');
      if (mh) {
        var form = mh.closest('form');
        var pidEl = form ? form.querySelector('[name="product-id"]') : null;
        var vidEl = form ? form.querySelector('[name="id"]') : null;
        var mid = (pidEl && pidEl.value) || (vidEl && vidEl.value);
        if (mid && typeof has === 'function' && !has(String(mid))) {
          var pimg = pdpMediaImg();
          flyToBanner(pimg || mh, (pimg && (pimg.currentSrc || pimg.src)) || (window.MUSTERBOX_PDP && MUSTERBOX_PDP.img));
        }
        return;
      }
      if (typeof isPdpMusterContext === 'function' && isPdpMusterContext()) {
        var addBtn = tg.closest('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] .product-form__submit, [name="add"].product-form__submit');
        if (addBtn && window.MUSTERBOX_PDP && MUSTERBOX_PDP.id && typeof has === 'function' && !has(String(MUSTERBOX_PDP.id))) {
          var pimg2 = pdpMediaImg();
          flyToBanner(pimg2 || addBtn, (pimg2 && (pimg2.currentSrc || pimg2.src)) || MUSTERBOX_PDP.img);
        }
      }
    }, true);

    // 5) Positiver Hinweis: "Gut gemacht" ueber der Muster-Meldung
    toast = function (msg) {
      if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'muster-toast'; document.body.appendChild(toastEl); }
      var positive = /hinzugef|ausgew/i.test(String(msg));
      if (positive) {
        toastEl.innerHTML = '<strong style="display:block;font-weight:700;font-size:14px;margin-bottom:2px">Gut gemacht</strong><span>' + String(msg).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }) + '</span>';
      } else {
        toastEl.textContent = msg;
      }
      toastEl.classList.add('is-visible');
      clearTimeout(toastEl._t);
      toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
    };

    // 6) Projekt-Fragen vor der Bestellung (04.08.2026)
    //    Klick auf "Kostenlos bestellen" zeigt zwei optionale Ein-Tap-Fragen
    //    (Projektgroesse in m² + Projektstart). Antworten werden als Cart-Attribute
    //    gespeichert und landen als Bestell-Attribute ("Zusätzliche Details") auf der Order.
    //    NUR bei Terrassen-Mustern (Dielen/Platten) im Musterkorb – sonst wird direkt
    //    bestellt (mbHasTerraceSample). "Ueberspringen" bestellt ohne Antworten.
    //    Einstieg: window.mbOpenQuestions (mb-part2a.js).
    var _origCloseModal = closeModal;
    closeModal = function () { window.__mbQuestionsOpen = false; _origCloseModal(); };

    var MB_Q = [
      { key: 'Projektgröße', title: 'Wie groß ist dein Projekt?', opts: ['Unter 10 m²', '10–25 m²', '25–50 m²', 'Über 50 m²'] },
      { key: 'Projektstart', title: 'Wann startest du dein Projekt?', opts: ['So bald wie möglich', 'In 1–3 Monaten', 'In 3–6 Monaten', 'Noch unklar'] }
    ];
    var mbAnswers = {};
    // Terrassen-Erkennung ueber den Produktnamen des Musters:
    // Zaun/Akustik/Wand/SPC/Stelzlager zaehlen NICHT als Terrasse; Dielen, Terrassenplatten,
    // Massivdielen und Hohlkammer-Dielen schon. Unbekannter Name -> im Zweifel Fragen zeigen.
    function mbHasTerraceSample() {
      for (var i = 0; i < selected.length; i++) {
        var it = selected[i] || {};
        var n = String(it.name || '');
        if (!n) return true;
        if (/akustik|wandverkleidung|wandpaneel|spc|zaun|stelzlager/i.test(n)) continue;
        if (/terrass|diele|hohlkammer|platte/i.test(n)) return true;
      }
      return false;
    }
    function mbEnsureQStyles() {
      if (document.getElementById('mb-q-style')) return;
      var st = document.createElement('style');
      st.id = 'mb-q-style';
      st.textContent = '.mb-q__group{margin:16px 0 4px}.mb-q__label{font-weight:700;font-size:15px;margin:0 0 8px;color:#231F20}.mb-q__chips{display:flex;flex-wrap:wrap;gap:8px}.mb-q__chip{cursor:pointer;border:1.5px solid #d9d3cc;background:#fff;color:#231F20;border-radius:999px;padding:10px 14px;font-size:14px;font-weight:600;font-family:inherit;line-height:1;transition:border-color .12s,background .12s,color .12s}.mb-q__chip.is-on{background:#C05621;border-color:#C05621;color:#fff}.mb-q__skip{display:block;margin:10px auto 0;background:none;border:0;cursor:pointer;font-size:13px;font-weight:600;color:#8a8178;text-decoration:underline;font-family:inherit}.mb-q__back{background:none;border:0;cursor:pointer;padding:0;font-size:13px;font-weight:600;color:#8a8178;font-family:inherit;margin-bottom:2px;text-align:left}';
      document.head.appendChild(st);
    }
    function mbSubmitOrder() {
      var attrs = {};
      for (var i = 0; i < MB_Q.length; i++) {
        var q = MB_Q[i];
        if (mbAnswers[q.key]) attrs[q.key] = mbAnswers[q.key];
      }
      var sb = document.querySelector('.mb-q__send');
      if (sb) { sb.disabled = true; sb.textContent = 'Wird hinzugefügt…'; }
      window.__mbQuestionsOpen = false;
      var go = function () { addAllToCart(); };
      if (Object.keys(attrs).length) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).then(go, go);
      } else { go(); }
    }
    window.mbOpenQuestions = function () {
      if (!mbHasTerraceSample()) { addAllToCart(); return; } // keine Terrassen-Muster -> direkt bestellen
      var card = ensureModal().querySelector('.muster-modal__card');
      window.__mbQuestionsOpen = true;
      modalSig = '__questions__';
      mbEnsureQStyles();
      var groups = '';
      for (var i = 0; i < MB_Q.length; i++) {
        var q = MB_Q[i];
        var chips = '';
        for (var j = 0; j < q.opts.length; j++) {
          var on = mbAnswers[q.key] === q.opts[j];
          chips += '<button type="button" class="mb-q__chip' + (on ? ' is-on' : '') + '" data-q="' + esc(q.key) + '" data-val="' + esc(q.opts[j]) + '">' + esc(q.opts[j]) + '</button>';
        }
        groups += '<div class="mb-q__group"><p class="mb-q__label">' + esc(q.title) + '</p><div class="mb-q__chips">' + chips + '</div></div>';
      }
      card.innerHTML =
        '<button type="button" class="muster-modal__close" aria-label="Schließen">' + ICON_X + '</button>' +
        '<div class="muster-modal__body">' +
        '<button type="button" class="mb-q__back">‹ Zurück zur Auswahl</button>' +
        '<h2 class="muster-modal__title">Fast geschafft!</h2>' +
        '<p class="muster-modal__hint">Verrate uns noch kurz zwei Dinge – so können wir dich besser beraten.</p>' +
        groups +
        '<div class="muster-modal__actions">' +
        '<button type="button" class="muster-modal__cta mb-q__send">Jetzt kostenlos bestellen</button>' +
        '<button type="button" class="mb-q__skip">Überspringen und direkt bestellen</button>' +
        '</div></div>';
      card.querySelector('.muster-modal__close').addEventListener('click', closeModal);
      card.querySelector('.mb-q__back').addEventListener('click', function () {
        window.__mbQuestionsOpen = false;
        modalSig = null;
        renderModal();
      });
      Array.prototype.forEach.call(card.querySelectorAll('.mb-q__chip'), function (ch) {
        ch.addEventListener('click', function () {
          var k = ch.getAttribute('data-q'), v = ch.getAttribute('data-val');
          mbAnswers[k] = (mbAnswers[k] === v) ? null : v;
          Array.prototype.forEach.call(card.querySelectorAll('.mb-q__chip[data-q="' + k + '"]'), function (o) {
            o.classList.toggle('is-on', o.getAttribute('data-val') === mbAnswers[k]);
          });
        });
      });
      card.querySelector('.mb-q__send').addEventListener('click', mbSubmitOrder);
      card.querySelector('.mb-q__skip').addEventListener('click', function () { mbAnswers = {}; mbSubmitOrder(); });
    };

    updateReopen();
    applyTrayVisibility();
  })();
